import { IconBaseProps, IconType } from "@/types/icon";

export const ChevronUpOutlineIcon: IconType = ({
  size = 24,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M7.69622 6.1663L7.69628 6.16619C7.77575 6.09072 7.88872 6.04394 8.01153 6.04394L7.69622 6.1663ZM7.69622 6.1663L3.96289 9.71457L3.96294 9.71463M7.69622 6.1663L3.96294 9.71463M3.96294 9.71463L3.95655 9.72049M3.96294 9.71463L3.95655 9.72049M3.95655 9.72049C3.91618 9.75755 3.88547 9.80047 3.86489 9.84601C3.84435 9.89147 3.83395 9.93934 3.83351 9.98706C3.83307 10.0348 3.8426 10.0827 3.86225 10.1284C3.88194 10.1741 3.91176 10.2174 3.95132 10.255C3.99094 10.2926 4.03944 10.3236 4.09462 10.345C4.14983 10.3665 4.2098 10.3776 4.27081 10.3771C4.33182 10.3766 4.39151 10.3646 4.44622 10.3423C4.50088 10.32 4.54867 10.2882 4.58746 10.2501L4.58741 10.250M3.95655 9.72049L4.58741 10.250M4.58741 10.250L4.59371 10.244M4.58741 10.250L4.59371 10.244M4.59371 10.244L7.66717 7.32289L8.01163 6.99552M4.59371 10.244L8.01163 6.99552M8.01163 6.99552L8.35609 7.32289M8.01163 6.99552L8.35609 7.32289M8.35609 7.32289L11.4258 10.2404C11.5059 10.3127 11.6173 10.3564 11.7375 10.3554C11.8589 10.3544 11.9704 10.3079 12.049 10.2332C12.1268 10.1593 12.166 10.0647 12.1668 9.9715C12.1677 9.87935 12.1311 9.78549 12.0566 9.71095L8.32704 6.1663L8.32699 6.16619M8.35609 7.32289L8.32699 6.16619M8.32699 6.16619C8.24751 6.09072 8.13454 6.04394 8.01173 6.04394L8.32699 6.16619Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};
